// extracted by mini-css-extract-plugin
export var container = "_46-0";
export var disabled = "_46-4";
export var fullWidth = "_46-3";
export var lined = "_46-1";
export var selected = "_46-5";
export var tab = "_46-2";